import { ThirdPartyEvaluationResult } from './thirdparty-evaluation-result';
import { ThirdPartyTracingActionListItem } from './thirdparty-tracingaction-listitem';
import { ThirdPartyEvaluationStatus } from './thirdparty-evaluation-status';

export class ThirdPartyEvaluationApprovementRequest {
    evaluationStateDto: ThirdPartyEvaluationStatus;
    suggestionResultDto: ThirdPartyEvaluationResult;
    taskDtos: ThirdPartyTracingActionListItem[];
    nextStepSelectedByUser: number;

    constructor() { 
        this.suggestionResultDto = new ThirdPartyEvaluationResult();
        this.taskDtos = [];
        this.nextStepSelectedByUser = 0;      
    }
}